import { computed, ref } from "vue";
import { roomState } from "./room";
import { isSelfAdmin } from "./adminsState";
import { ws_instance } from "../websocket/ws-instance";
import { authState } from "./auth";
import { fetcher } from "../api/fetcher";
import { finishState, goFinish } from "./finishState";

const internalApproved = ref(false);

export const selfApproved = computed(() => {
  if (roomState.waitRoom === false) return true;
  else if (isSelfAdmin.value) return true;
  else return internalApproved.value;
});

export async function setupApprovedSelfData() {
  ws_instance.addEventListener("enter-request-approved", (data: string) => {
    if (data === authState.id) {
      internalApproved.value = true;
    }
  });
  ws_instance.addEventListener("enter-request-rejected", (data: string) => {
    if (data === authState.id) {
      goFinish("rejected");
    }
  });
  ws_instance.addEventListener(
    "enter-request-approved-list",
    (data: string[]) => {
      if (data.includes(authState.id)) {
        internalApproved.value = true;
      }
    },
  );
  ws_instance.addEventListener(
    "enter-request-rejected-list",
    (data: string[]) => {
      if (data.includes(authState.id)) {
        goFinish("rejected");
      }
    },
  );
  ws_instance.addEventListener("enter-request-revoked", (data: string) => {
    if (data === authState.id) {
      window.location.replace(window.location.href + "?wait=true");
      finishState.fixReload = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(true);
        }, 3000);
      });
    }
  });
  if (!isSelfAdmin.value) {
    await fetcher
      .get({
        path: `/wait-room/check/${roomState.id}`,
      })
      .then((res: { data: boolean }) => {
        internalApproved.value = res.data;
      });
  } else {
    internalApproved.value = true
  }
}

export async function requestEnter() {
  await fetcher.post({
    path: "/wait-room/request",
    payload: {
      roomId: roomState.id,
    },
  });
}
